<template>
<div class="box customer-info-container">
  <customer-section-header v-if="isPpaApproval" title="Customer Info" :collapsed="isCollapsed" v-on:collapsed-status-changed="onCollapsedStatusChanged" :syncingFailed="syncingFailed" :isSyncing="isSyncing" v-on:sync-clicked="syncCustomer()" :allowSync="allowSync"></customer-section-header>
  <div :class="isPpaApproval ? 'is-centered' : ''" class="columns is-mobile is-multiline" v-if="customer" style="padding: 0;" :style="isPpaApproval ? ' margin-top: 5px; margin-bottom: 20px !important;' : ''">
    <div v-if="isPpaApproval && isSyncing" class="column is-12">
      <div>
        <label class="is-inline-block is-size-7 has-text-success refresh-status-label" v-if="isSyncing"> Syncing customer...</label>
      </div>
    </div>
    <template>
      <div :class="isPpaApproval ? 'column is-4' : 'column is-6'">
        <div class="field">
          <label class="label">
            {{ customerNameLabel }}
            <dealer-peak-control v-if="customer" :key="currentCustomerId" :customer="customer" :customerId="currentCustomerId"></dealer-peak-control>
            <dp-resync-component v-if="customer" :id="currentCustomerId" :mobile="customer.mobile" :email="customer.email"></dp-resync-component>
          </label>
          <div class="field is-size-7">
            <a v-if="!isPpaApproval" class="is-link" @click="openCustomerRecord()">
              {{ customer.fullName }}
            </a>
            <span v-else>{{ customer.fullName }}</span>
            <customer-pop-component v-model="currentCustomerId"></customer-pop-component>
          </div>
        </div>
      </div>
      <div v-if="!isPpaApproval" class="column is-6">
        <div class="field">
          <label class="label">Home</label>
          <div class="field is-size-7">
            <click-to-call v-tooltip="customer.home + ' - Click to copy contact home to your clipboard'" :key="'ctc' + currentCustomerId" :destinationLineProp="customer.home" :receiverIdProp="currentCustomerId" :customerName="customer.fullName" @click.stop.prevent="onCopyInfo(unmask(customer.home))"></click-to-call>
          </div>
        </div>
      </div>
      <div :class="isPpaApproval ? 'column is-4' : 'column is-6'">
        <div class="field">
          <label class="label">Mobile</label>
          <div class="field is-size-7">
            <click-to-call v-tooltip="customer.mobile + ' - Click to copy contact mobile to your clipboard'" :key="'ctc' + currentCustomerId" :destinationLineProp="customer.mobile" :receiverIdProp="currentCustomerId" :customerName="customer.fullName" @click.stop.prevent="onCopyInfo(unmask(customer.mobile))"></click-to-call>
          </div>
        </div>
      </div>
      <div :class="isPpaApproval ? 'column is-4' : 'column is-6'">
        <div class="field">
          <label class="label">Contact Email</label>
          <div class="field is-size-7">
            <span class="has-text-link clickable" v-tooltip="customer.email + ' - Click to copy contact email to your clipboard'" @click.stop.prevent="onCopyInfo(customer.email)">{{ customer.email }}</span>
          </div>
        </div>
      </div>
      <div v-if="isPpaApproval" class="column is-4">
        <div class="field">
          <label class="label">Is Active</label>
          <div class="field is-size-7">
            {{ isActiveLeadStatus ? 'Yes' : 'No' }}
          </div>
        </div>
      </div>
      <div v-if="isPpaApproval" class="column is-4">
        <div class="field">
          <label class="label">Dealer Peak Lead Status</label>
          <div class="field is-size-7">
            {{ leadStatus }}
          </div>
        </div>
      </div>
      <div v-if="isPpaApproval" class="column is-4">
        <div class="field">
          <label class="label">Trade</label>
          <div class="field is-size-7">
            {{ trade }}
          </div>
        </div>
      </div>
      <div v-if="isPpaApproval" class="column is-12 no-h-padding">
        <b-table
          :data="this.vehicleInterests"
          :sortable="false"
          :mobile-cards="false"
          :selecteable="false"
          :row-class="() => 'interest-event-row'">
          <template slot-scope="props">
            <b-table-column field="vinNo" label="Vin No" class="interest-event-column" :title="props.row.inventory.vinNo">
              {{ props.row.inventory.vinNo }}
            </b-table-column>
            <b-table-column field="listName" label="Vehicle" class="interest-event-column">
              <a @click.stop.prevent="onViewInventory(props.row.inventory.id)" v-if="hasInventoryViewAccess">
                <span class="has-text-weight-semibold">{{ props.row.inventory.listName }}</span>
              </a>
              <span v-else>{{ props.row.inventory.listName }}</span>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="has-text-centered">
                <p><b-icon icon="emoticon-sad" size="is-large"></b-icon></p>
                <p>No vehicles of interest.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </template>
  </div>
</div>
</template>

<script>
import utilitiesMixin from '@/mixins/generic/utilities'
import dealerPeakService from '@/services/dealerPeakService'
import CustomerSectionHeader from '@/components/generic/CustomerSectionHeader'
import DealerPeakControl from '@/components/generic/DealerPeakControl'
import CustomerPopComponent from '@/components/generic/CustomerPopComponent'
import ClickToCallComponent from '@/components/generic/ClickToCallComponent'
import DealerPeakCustomerResyncComponent from '@/components/generic/DealerPeakCustomerResyncComponent'

import { createNamespacedHelpers } from 'vuex'
const mapDealerState = createNamespacedHelpers('dealer').mapState
const mapUserGetters = createNamespacedHelpers('user').mapGetters

export default {
  name: 'CustomerInfoControl',
  mixins: [utilitiesMixin],
  components: {
    'customer-section-header': CustomerSectionHeader,
    'dealer-peak-control': DealerPeakControl,
    'customer-pop-component': CustomerPopComponent,
    'click-to-call': ClickToCallComponent,
    'dp-resync-component': DealerPeakCustomerResyncComponent
  },
  props: {
    customerId: {
      type: Number,
      default: 0
    },
    customerNameLabel: {
      type: String,
      default: 'Customer Name'
    },
    customerMobile: {
      type: String,
      default: ''
    },
    customerEmail: {
      type: String,
      default: ''
    },
    displayMode: {
      type: String,
      default: 'Standard'
    },
    allowSync: {
      type: Boolean,
      default: true
    },
    inventoryId: {
      type: Number,
      default: 0
    },
    isPpaApproval: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      serverErrors: [],
      serverErrorMessage: '',
      isSyncing: false,
      syncingFailed: false,
      currentCustomerId: this.customerId,
      customer: null,
      isCollapsed: false
    }
  },
  computed: {
    ...mapUserGetters(['hasFeatureAccess']),
    ...mapDealerState(['currentDealer']),
    activeLeadStatus: function () {
      let status = '-'
      if (this.customer) {
        const leadWithMatchingId = this.customer.customerLeads.find(lead => lead.status == 'Active' &&
          lead.trades?.some(trade => trade.inventory?.id === this.inventoryId)
        )

        if (leadWithMatchingId) {
          status = leadWithMatchingId.leadStatus
        }
      }
      return status
    },
    isActiveLeadStatus: function () {
      return this.activeLeadStatus !== '-' && this.activeLeadStatus !== ''
    },
    leadStatus: function () {
      let status = '-'
      if (this.customer) {
        const leadWithMatchingId = this.customer.customerLeads.find(lead => lead.trades?.some(trade => trade.inventory?.id === this.inventoryId))

        if (leadWithMatchingId) {
          status = leadWithMatchingId.leadStatus
        }
      }
      return status
    },
    trade: function () {
      let trade = ''
      if (this.customer) {
        const leadWithMatchingId = this.customer.customerLeads.find(lead => lead.trades?.some(trade => trade.inventory?.id === this.inventoryId))

        if (leadWithMatchingId) {
          const matchingInventory = leadWithMatchingId.trades?.find(trade => trade.inventory?.id === this.inventoryId)?.inventory
          trade = matchingInventory.listName
        }
      }
      return trade
    },
    vehicleInterests: function () {
      if (!this.customer || !this.customer.customerLeads) return []

      const leadWithMatchingId = this.customer.customerLeads.find(lead => lead.trades?.some(trade => trade.inventory?.id === this.inventoryId))
      if (!leadWithMatchingId) return []

      const leadsWithInventory = leadWithMatchingId.vehicleInterests.filter(vehicleInterest => vehicleInterest.inventory != null)
      return leadsWithInventory
    },
    hasInventoryViewAccess: function () {
      return this.hasFeatureAccess('inventory.view')
    }
  },
  methods: {
    syncCustomer: async function () {
      this.syncingFailed = false
      this.isSyncing = true
      let model = {
        number: this.unmask(this.customerMobile),
        email: this.customerEmail,
        customerType: 'Lead',
        customerId: this.currentCustomerId,
        source: 'LIVE',
        clearExistingLeads: true,
        openLeadsOnly: true
      }
      try {
        let response = await dealerPeakService.syncCustomer(model)
        if (response.data !== null) {
          this.customer = response.bestLiveMatch
          this.emitLeadStatus()
        }
        this.isSyncing = false
      } catch (err) {
        this.syncingFailed = true
        this.isSyncing = false
      }
    },
    onCollapsedStatusChanged: function (newValue) {
      this.isCollapsed = newValue
    },
    onCopyInfo: function (text) {
      let that = this
      this.$copyText(text).then(function (e) {
        that.$buefy.toast.open(
          {
            duration: 2500,
            message: text + ' copied to clipboard',
            position: 'is-top',
            type: 'is-info'
          })
      }, function (e) {
        that.$buefy.toast.open(
          {
            duration: 2500,
            message: 'Could not copy info to clipboard',
            position: 'is-top',
            type: 'is-warning'
          })
      })
    },
    emitLeadStatus: function () {
      let status = ''
      if (this.customer && this.customer.customerLeads && this.inventoryId) {
        const leadWithMatchingId = this.customer.customerLeads.find(lead => lead.trades?.some(trade => trade.inventory?.id === this.inventoryId))
        if (leadWithMatchingId) {
          status = leadWithMatchingId.leadStatus
        }
      }
      let crmLeadModel = {
        status: status,
        trade: this.trade
      }
      this.$emit('lead-status', crmLeadModel)
    },
    openCustomerRecord () {
      if (!this.isPpaApproval) {
        this.$router.push({name: 'CustomersQuickView', params: { id: this.customer.id }})
      }
    },
    onViewInventory: function (inventoryId) {
      if (!inventoryId) return
      this.$emit('close')
      this.$router.push({name: 'InventoryQuickView', params: { id: inventoryId }})
    }
  },
  watch: {
    customerId: function (newValue, oldValue) {
      this.currentCustomerId = newValue
    }
  },
  mounted: function () {
    // If there are no appraisals for the vehicle then run one
    if (this.currentCustomerId) {
      this.syncCustomer()
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .tolerance-error-icon {
    margin-left:5px;
  }

  .refresh-status-label {
    margin-left:1em;
  }

  .interest-event-row {
    text-align: left;
    vertical-align:middle;
  }

  .interest-event-column {
    text-align: left;
    vertical-align:middle;
  }
</style>
